import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuButton from "../../components/DixuButton/DixuButton";
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuImage from "../../components/DixuImage/DixuImage";
import DixuLink from "../../components/DixuLink/DixuLink";
import DixuLinkAnchor from "../../components/DixuLinkAnchor/DixuLinkAnchor";
import DixuRealtorExperienceCard from "../../components/DixuRealtorExperienceCard/DixuRealtorExperienceCard";
import DixuText from "../../components/DixuText/DixuText";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import { useTranslation } from "../../i18n";
import React from 'react';
const HeroSection = () => {
  const {
    t
  } = useTranslation(['forrealtor']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    subtitle: t('forrealtor:Hero.Subtitle'),
    subtitleContainerProps: {
      maxWidth: 'md'
    },
    titleProps: {
      hyphens: false
    }
  }, t('forrealtor:Hero.Title'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "xl",
    verticalPadding: false,
    horizontalPadding: false
  }, /*#__PURE__*/React.createElement(DixuImage, {
    src: "/images/linear_device_mashup.png",
    aspectRatio: "2:1",
    fit: "contain"
  }))))));
};
const KeyPointsSection = () => {
  const {
    t
  } = useTranslation(['forrealtor']);
  const keyPointItems = [{
    title: t('forrealtor:KeyPoints.TypeLessSellMore.Title'),
    content: t('forrealtor:KeyPoints.TypeLessSellMore.Content')
  }, {
    title: t('forrealtor:KeyPoints.CustomerOriented.Title'),
    content: t('forrealtor:KeyPoints.CustomerOriented.Content')
  }, {
    title: t('forrealtor:KeyPoints.AllFromOneSystem.Title'),
    content: t('forrealtor:KeyPoints.AllFromOneSystem.Content')
  }, {
    title: t('forrealtor:KeyPoints.CustomerExperience.Title'),
    content: t('forrealtor:KeyPoints.CustomerExperience.Content')
  }, {
    title: t('forrealtor:KeyPoints.NewClientsWithoutAcquisition.Title'),
    content: t('forrealtor:KeyPoints.NewClientsWithoutAcquisition.Content')
  }].map(item => {
    const {
      title,
      content
    } = item;
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: title,
      span: 24
    }, /*#__PURE__*/React.createElement(DixuTitle, {
      level: "2",
      appear: "3",
      weight: "bold"
    }, title), /*#__PURE__*/React.createElement(DixuText, {
      font: "3",
      color: "2-6",
      weight: "medium",
      responsive: true,
      block: true
    }, content));
  });
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "lg",
    verticalPadding: "xxxl"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [40, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 15
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 48]
  }, keyPointItems)), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 9
  }, /*#__PURE__*/React.createElement(DixuRealtorExperienceCard, {
    realtor: {
      avatar: require("../../public/images/realtor-8.png"),
      name: 'Patrik Sariola',
      jobTitle: 'Local LKV'
    },
    fullHeight: false,
    align: "left",
    content: t('forrealtor:KeyPoints.LiftedExperience'),
    titlePosition: "top",
    wide: true,
    quotes: true
  })))));
};
const WantToKnowMoreSection = () => {
  const {
    t
  } = useTranslation(['common', 'forrealtor']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "md",
    verticalPadding: "xxxl"
  }, /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    level: "2",
    containerProps: {
      maxWidth: 'sm'
    },
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center"
    }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton.Group, {
      justify: "center"
    }, /*#__PURE__*/React.createElement(DixuButton, {
      type: "primary",
      size: "lg",
      href: "https://linear.fi/valitysjarjestelma/",
      external: true
    }, t('Kyllä!'))))))
  }, `Haluatko tietää lisää\nLinear-välitysjärjestelmästä?`)));
};
const RealtorExperiencesSection = () => {
  const {
    t
  } = useTranslation(['common', 'forrealtor']);
  const experiences = [{
    realtor: {
      avatar: require("../../public/images/realtor-11.jpg"),
      name: 'Jouni Paasio',
      jobTitle: 'Näytönpaikka LKV Turku'
    },
    content: 'Päätös uuden välitysjärjestelmän käyttöönotosta oli meille vaikea. Tunsimme olemassa olevat järjestelmät ja kaipasimme selkeästi jotain uutta, innovatiivista lähestymistä. Päädyimme pitkän harkinnan jälkeen Linear-järjestelmään.\n\nTiesimme sen olevan osin keskeneräinen projekti, mutta visiot tulevaisuudesta saivat meidät vakuuttumaan ennen kaikkea suunnasta, johon järjestelmää kehitetään. Alku ei ollut ruusuilla tanssimista. Korjauksia, vaatimuksia, valituksia lähes päivittäin. Uuden oppiminen, ja etenkin vanhasta pois oppiminen, vie oman aikansa. Kokeneet välittäjät kun ovat tottuneet tekemään asiat tietyllä tavalla, oli se sitten järkevää tai ei.\n\nJo alkuvaiheessa vakuutuimme kehityksen vauhdista ja tekemisen tasosta ja innosta. Puolen vuoden käytön ja kehityksen jälkeen ollaankin jo tilanteessa, jossa kaikki päivittäiset rutiinit sujuvat moitteettomasti, kehitystä on tapahtunut valtavasti ja uutta luodaan jatkuvasti.\n\nVälittäjän työtä helpottavat ideat tulevat tuotantoon nopeasti ja ajatukset automaation ja tekoälyn käytöstä monella saralla luovat vahvaa uskoa tulevaan. Lisäksi myynnin seuranta ja raportointi työkalut ovat jo nyt seuraavalla tasolla. Asiakaspalvelun laatu ja tarpeiden huomioon ottaminen on ollut alusta asti täyttä timanttia. Me koemme olevamme ohituskaistalla ja vauhtia riittää vallan mainiosti.'
  }, {
    realtor: {
      avatar: require("../../public/images/realtor-12.png"),
      name: 'Antti Pietilä',
      jobTitle: 'Helmikodit Rovaniemi'
    },
    content: 'Meillä on ollut käytössä toimintamme aikana 3 eri järjestelmää, joista Linear nyt viimeisin. Vasta näin 1 kk käyttökokemus on ollut vakuuttava.\n\nJärjestelmä toimii hyvin pöytäkoneella, pädillä ja puhelimella. Sähköiset toimeksiannot ja ostotarjoukset toimivat erinomaisesti ja ovat välittäjän sekä asiakkaan näkökulmasta nopeita käyttää. Esitteet ovat hyvin toteutettu ja tiedoiltaan todella laajat. Kauppakirjat myös laadukkaasti toteutettu ja sinne tuleva tieto on kattava verrattuna muiden järjestelmien kauppakirjoihin.\n\nHaimme välitysjärjestelmän vaihtoa miettiessä mahdollisimman hyvin kaikilla laitteilla toimivaa järjestelmää ja siinä on kyllä onnistuttu erinomaisesti. Jokaista ohjelmaa voi aina parantaa, mutta olen positiivisesti yllättynyt että mahdollisten parannusehdotusten suhteen ollaan avoimia ja niitä tehdään hyvällä vauhdilla. Voin suositella lämpimästi Linear-järjestelmää kaikille!'
  }, {
    realtor: {
      avatar: require("../../public/images/realtor-10.jpeg"),
      name: 'Toni Leskinen',
      jobTitle: 'Rive Helsinki'
    },
    content: 'Linear-välitysjärjestelmä on helppokäyttöinen ja nopeuttaa paljon välittäjien työtä. Lisäksi allekirjoitukset toimivat kokonaisvaltaisesti todella hyvin. Ne pienet muutokset, joita olemme toivoneet, on tuotettu todella nopeasti uusiksi ominaisuuksiksi.\n\nOlemme tilanneet mm. pohjakuvia, jotka tulevat nopeasti ja helposti suoraan myytävän kohteen tietoihin. Hyvä ominaisuus on se, että kaikista saapuneista palveluista tulee myös ilmoitus sähköpostiin: tämä auttaa välittäjää pysymään ajan tasalla.\n\nLinear-välitysjärjestelmä on kokonaisuudessaan välitysliikkeelle jouheva ja helppokäyttöinen muihin mainitsemattomiin kilpailijoihin nähden. Olen todella tyytyväinen!'
  }].map(experience => {
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: experience.realtor.name,
      xs: 24,
      xl: 8
    }, /*#__PURE__*/React.createElement(DixuRealtorExperienceCard, _objectSpread({
      fullHeight: false,
      align: 'left',
      wide: true,
      readMore: true
    }, experience)));
  });
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    verticalPadding: "xxxl"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 48]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuLinkAnchor, {
    id: "experiences",
    offset: "0"
  }), /*#__PURE__*/React.createElement(DixuTitle.PageTitle, null, t('forrealtor:RealtorExperiences.Title'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [40, 60]
  }, experiences)))));
};
const BecomeAPartnerRealtorSection = () => {
  const {
    t
  } = useTranslation(['common', 'forrealtor']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    verticalPadding: "xxxl"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, {
      xs: 16,
      xl: 32
    }]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, t('forrealtor:BecomeAPartnerRealtor.Subtitle.Part1'), /*#__PURE__*/React.createElement(DixuLink, {
      href: "/ota-yhteytta",
      color: "2-8",
      weight: "bold"
    }, t('forrealtor:BecomeAPartnerRealtor.Subtitle.Part2')), t('forrealtor:BecomeAPartnerRealtor.Subtitle.Part3'))
  }, t('forrealtor:BecomeAPartnerRealtor.Title'))))));
};
const DixuForRealtorScreen = () => {
  const {
    t
  } = useTranslation(['forrealtor']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: t('forrealtor:Metadata.Title'),
    description: t('forrealtor:Metadata.Description')
  }), /*#__PURE__*/React.createElement(HeroSection, null), /*#__PURE__*/React.createElement(KeyPointsSection, null), /*#__PURE__*/React.createElement(WantToKnowMoreSection, null), /*#__PURE__*/React.createElement(RealtorExperiencesSection, null), /*#__PURE__*/React.createElement(BecomeAPartnerRealtorSection, null));
};
export default DixuForRealtorScreen;